module.exports = __webpack_public_path__ + "static/img/nav-2.b7a6301.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/nav-2.png
// module id = FAYl
// module chunks = 1